import type {
  ApiErrorMetadata,
  LegacyApiAction,
  LegacyMiddlewareStore,
} from '../api-middleware.types';

function dispatchAction(
  store: LegacyMiddlewareStore,
  action: LegacyApiAction,
  { status, msg, details = '' }: ApiErrorMetadata,
) {
  let errorMessage: string | undefined;
  const { type, meta, ...forwardedAction } = action;
  const { error } = meta;

  if (error && error[status]) {
    errorMessage = error[status];
  }

  if (typeof details === 'string' && details) {
    errorMessage = details;
  }

  if (!errorMessage) {
    errorMessage = msg;
  }

  store.dispatch({
    type: `${type}_ERROR`,
    ...forwardedAction,
    errorMessage,
  });
}

export { dispatchAction };
